import React from 'react';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
type InputProps = React.InputHTMLAttributes<HTMLInputElement>;
type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

// KDS-scoped low-level control wrappers.
// Keep these local to KDS until a shared design-system behavior is introduced.
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ type = 'button', ...props }, ref) => (
    <button ref={ref} type={type} {...props} />
  ),
);

Button.displayName = 'Button';

export const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => (
  <input ref={ref} {...props} />
));

Input.displayName = 'Input';

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>((props, ref) => (
  <select ref={ref} {...props} />
));

Select.displayName = 'Select';
